import React from 'react';
import ContentLoader from "react-content-loader"
import {Link} from 'react-router-dom';
import moment from 'moment';

import {config} from '../../../../config';
import coverSmall from "../../../../images/cover-small.jpg";
import {trancheAge} from '../../../../libs/helper';
import Avatar from '../../../components/Avatar';
import Icon from '../../../components/Icon';
import createLink from "../../../../libs/createLink";

class MeetMemberCard extends React.Component {
    constructor(props) {
        super(props);
        this.lookFor = [
            {title: "Non defini", _id: 0, gender: 0},
            {title: "Femme hétéro", _id: 1, gender: 2},
            {title: "Femme lesbienne", _id: 2, gender: 2},
            {title: "Femme bi", _id: 3, gender: 2},
            {title: "Homme", _id: 4, gender: 1},
            {title: "Homme gay", _id: 5, gender: 1},
            {title: "Homme bi", _id: 6, gender: 1},
            {title: "Couple", _id: 7, gender: 3},
            {title: "Couple homo", _id: 8, gender: 5},
            {title: "Couple lesbien", _id: 9, gender: 4},
            {title: "couple femme bi", _id: 10, gender: 3},
            {title: "couple homme bi", _id: 11, gender: 3},
            {title: "Trav / Trans", _id: 12, gender: 6},
        ];
    }
// lookFor  0 =>non defini // 1=>femmehetero, 2=>femmelesbienne, 3=>femmebi, 4=>hommehetero, 5=>hommegay, 6=>hommebi, 7=>couplehetero, 8=>Couple homo, 9=>Couple lesbien, 10=>couplefemmeb, 11=>couplehommebi, 12=>travtrans
// 0=>NC, 1=>Homme, 2=>Femme, 3=>Couple, 4=>Couple lesbien, 5=>Couple gay, 6=>Travesti
    render() {
        let userLook = this.props.profile.lookingFor.filter(item => item !== null && item !== 0) || [];
        let lookFor = this.lookFor.filter((item) => userLook.includes(item._id));
        // console.log(lookFor);
        let currentAge = this.props.profile.informations[0] && this.props.profile.informations[0].birthday ? moment().diff(this.props.profile.informations[0].birthday, 'years') : '';
        let trancheAge1 = trancheAge(currentAge);
        let currentAge2 = this.props.profile.informations[1] && this.props.profile.informations[1].birthday ? moment().diff(this.props.profile.informations[1].birthday, 'years') : '';
        let trancheAge2 = trancheAge(currentAge2);

        if (this.props.gender === 3 && trancheAge !== "" && trancheAge2 !== "") {
            let age1 = trancheAge1.split('-');
            let age2 = trancheAge2.split('-');
            if (age2[0] < age1[0]) {
                trancheAge1 = `${age2[0]} ${age1[1]}`
            } else if (age2[0] > age1[0]) {
                trancheAge1 = `${age1[0]} - ${age2[1]}`
            }
        }
        let message = this.props.profile.description.length >= 60 ? this.props.profile.description.substring(0, 60) + "..." : this.props.profile.description;

        return (
            <div className="members-card">
                {this.props.usersLoading ? (
                    <ContentLoader
                        height={290}
                        width={253}
                        speed={2}
                        ariaLabel={false}
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"

                    >
                        <rect x="0.44" y="-0.39" rx="0" ry="0" width="344.69" height="115"/>
                        <circle cx="123.88" cy="115.05" r="38.44"/>
                        <rect x="7.44" y="175.61" rx="0" ry="0" width="121" height="7"/>
                        <rect x="8.44" y="189.61" rx="0" ry="0" width="118" height="7.02"/>
                        <rect x="8.44" y="244.61" rx="0" ry="0" width="218" height="7.04"/>
                        <rect x="9.44" y="263.61" rx="0" ry="0" width="150" height="7.04"/>
                        <rect x="8.1544" y="225.61" rx="0" ry="0" width="218" height="6.96"/>
                    </ContentLoader>
                ) : (
                    <div className="wrapper">
                        <div className="member-card-topline">
                            <div className={`dot-status ${this.props.online ? "online" : "offline"}`}></div>
                            <Link to={createLink("userDating", this.props)}
                                  className="black-layer" rel={"nofollow"}></Link>
                            <Link to={createLink("userDating", this.props)}
                                  className="member-card-profil-header"
                                  style={{"backgroundImage": `url(${this.props.profile.cover || coverSmall})`}} rel={"nofollow"}></Link>
                            <Link to={createLink("userDating", this.props)} rel={"nofollow"}><Avatar width={60} height={60}
                                avatar={this.props.profile.avatar} gender={this.props.profile.gender} /></Link>
                            <div className="row">
                                <Link to={createLink("userDating", this.props)}
                                      className="text big black member-card-username-age" rel={"nofollow"}>{this.props.username}{trancheAge1.length !== 0 ? "," : ""} {trancheAge1}</Link>
                                {this.props.isCertified && (
                                    <div className="certified"><span><Icon type="certificate"/></span>Membre certifié
                                    </div>
                                )}
                            </div>
                            <div className="member-card-orientation">
                            <span
                                className={config.genderClass[this.props.profile.gender]}>{config.genderList[this.props.profile.gender]}</span>
                                <span className="look-for">cherche</span>
                                <span
                                    className={config.genderClass[lookFor && lookFor[0] && lookFor[0].gender]}>{lookFor && lookFor[0] && lookFor[0].title}</span>
                                {lookFor.length >= 2 && (
                                    <span className="show-more-informations">
                                        , ...
                                        <div className="column card">
                                          <Icon type="caret-up"/>
                                            {lookFor.slice(1).map((item, index) =>  (
                                                    <span key={index} className={config.genderClass[item.gender]}>{item.title}</span>
                                            ))}
                                        </div>
                                      </span>
                                )}
                            </div>
                        </div>
                        <Link to={createLink("userDating", this.props)}
                              className="member-card-content" rel={"nofollow"}>
                            {message}
                        </Link>
                    </div>
                )}
            </div>
        )
    }
}

export default MeetMemberCard;